module.exports = __webpack_public_path__ + "static/media/logo_bw.0f32bf56.svg";